import { render, staticRenderFns } from "./subjectsDashbord.vue?vue&type=template&id=18b54114&"
import script from "./subjectsDashbord.vue?vue&type=script&lang=js&"
export * from "./subjectsDashbord.vue?vue&type=script&lang=js&"
import style0 from "./subjectsDashbord.vue?vue&type=style&index=0&id=18b54114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports